import React from 'react';
import styled from 'styled-components';
import closeIcon from '../../assets/images/icons/navigate_cross.svg';

import { theme } from "../../configuration";

const DismissButtonContainer = styled.div`
  float: right;
  width: 30px;
  height: 20px;
  text-align: center;
  font-size: 1.4em;
  cursor: pointer;
  
  :hover {
    color: ${theme.colours.border};
  }
  
`;

const DismissButton = props => {
  return  (
    <DismissButtonContainer onClick={props.toggleForm}>
      <img src={closeIcon} alt={`Close`} style={{width:"24px"}} />
    </DismissButtonContainer>
  )
};

export default DismissButton;

